// Define a type for the stage prop
interface StatusProps {
  stage: 'idea' | 'planning' | 'executing' | 'completed' | 'archived' | string;
}

import { stageBgColorMap, stageTextColorMap } from "../../../../../constants/integrationTypes";

const Status = ({ stage }: StatusProps) => {
    const normalizedStage = (stage || "").toLowerCase();
    const bgClass = stageBgColorMap[normalizedStage] || "bg-gray-100 dark:bg-gray-800";
    const textClass = stageTextColorMap[normalizedStage] || "text-gray-700 dark:text-gray-200";
    return (
        <span className={`${bgClass} ${textClass} text-xs font-medium px-2.5 py-1 rounded `}>
            {stage}
        </span>
    )
}

export default Status;